import type { ScopeToken } from "@/types/internal-search";

const SCOPE_ALIASES: Record<string, ScopeToken> = {
  all: "all",
  a: "all",
  user: "user",
  users: "user",
  u: "user",
  order: "order",
  orders: "order",
  o: "order",
  contract: "contract",
  contracts: "contract",
  ct: "contract",
  cargo: "cargo",
  cargos: "cargo",
  cg: "cargo",
  product: "product",
  products: "product",
  p: "product",
  thread: "thread",
  threads: "thread",
  t: "thread",
  th: "thread",
};

export function normalizeInternalSearchQuery(input: string): string {
  return input.trim().toLowerCase().replace(/\s+/g, " ");
}

export function parseInternalSearchInput(
  inputQuery: string,
  explicitScope: ScopeToken = "all",
): {
  scope: ScopeToken;
  query: string;
  normalizedQuery: string;
} {
  const trimmed = inputQuery.trim();
  let scopeFromPrefix: ScopeToken = "all";
  let queryPart = trimmed;

  const bangPrefixMatch = trimmed.match(/^!([a-z]+)(?:\s*:\s*|\s+)?(.*)$/i);
  if (bangPrefixMatch) {
    const token = bangPrefixMatch[1]?.toLowerCase() ?? "";
    const mapped = SCOPE_ALIASES[token];
    if (mapped) {
      scopeFromPrefix = mapped;
      queryPart = bangPrefixMatch[2] ?? "";
    }
  } else {
    const prefixMatch = trimmed.match(/^([a-z]+)\s*:\s*(.*)$/i);
    if (prefixMatch) {
      const token = prefixMatch[1]?.toLowerCase() ?? "";
      const mapped = SCOPE_ALIASES[token];
      if (mapped) {
        scopeFromPrefix = mapped;
        queryPart = prefixMatch[2] ?? "";
      }
    }
  }

  const scope = explicitScope !== "all" ? explicitScope : scopeFromPrefix;

  return {
    scope,
    query: queryPart.trim(),
    normalizedQuery: normalizeInternalSearchQuery(queryPart),
  };
}

export function splitSearchTokens(input: string): string[] {
  return normalizeInternalSearchQuery(input)
    .split(" ")
    .map((token) => token.trim())
    .filter(Boolean);
}
